export default __webpack_public_path__ + "static/media/10.7861ccd1.jpg";